import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import { visuallyHidden } from '@mui/utils';
import React from 'react';
import { TableResponse } from '../../../api/tables';

export type Order = 'asc' | 'desc';

export interface HeadCell {
	id: keyof TableResponse;
	label: string;
	align?: 'inherit' | 'left' | 'center' | 'right' | 'justify';
	disableSort?: boolean;
}

interface EnhancedTableProps {
	headCells: HeadCell[];
	onRequestSort: (
		event: React.MouseEvent<unknown>,
		property: keyof TableResponse,
	) => void;
	order: Order;
	orderBy: string;
}

function TableHeader(props: EnhancedTableProps) {
	const { headCells, order, orderBy, onRequestSort } = props;
	const createSortHandler =
		(property: keyof TableResponse) => (event: React.MouseEvent<unknown>) => {
			onRequestSort(event, property);
		};

	return (
		<TableHead>
			<TableRow>
				{headCells.map(({ id, align = 'left', label, disableSort }) => (
					<TableCell
						sx={{ backgroundColor: 'white.lightest' }}
						key={id}
						align={align}
						sortDirection={orderBy === id ? order : false}
					>
						{!disableSort && (
							<TableSortLabel
								active={orderBy === id}
								direction={orderBy === id ? order : 'asc'}
								onClick={createSortHandler(id)}
							>
								{label}
								{orderBy === id ? (
									<Box component='span' sx={visuallyHidden}>
										{order === 'desc'
											? 'sorted descending'
											: 'sorted ascending'}
									</Box>
								) : null}
							</TableSortLabel>
						)}
						{disableSort && label}
					</TableCell>
				))}
			</TableRow>
		</TableHead>
	);
}

export default TableHeader;
